export default __webpack_public_path__ + "static/media/moon-of-appalacia.241e18c3.jpg";